module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-app",
    class: [("download-app_" + _vm.type)]
  }, [(_vm.type === 'type1') ? _c('v-container', {
    class: [("_" + _vm.type)],
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "_title"
  }, [_vm._v("\n          Scan QR code.\n          "), _c('br'), _vm._v("\n          Download the app.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n          Point your camera at the QR code & open the link.\n          "), _c('br'), _vm._v("\n          You will be redirected to the App Store or Google Play store.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "store-badge"
  }, [_c('img', {
    staticClass: "ios-store mr-3",
    attrs: {
      "src": _vm.iosStore,
      "width": "200",
      "alt": "ios app store icon"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "android-store",
    attrs: {
      "src": _vm.androidPlaystore,
      "width": "200",
      "alt": "android app store icon"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "qr-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.renderQR,
      "width": "100%",
      "alt": _vm.altText
    }
  })])])], 1)], 1) : (_vm.type === 'type2') ? _c('v-container', {
    class: [("_" + _vm.type)],
    attrs: {
      "grid-list-lg": ""
    }
  }, [(!_vm.showPlan) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "qrsection-card": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "details-card": ""
    }
  }, [_c('div', {
    staticClass: "dflex"
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": require('@/assets/ic_spotlight.svg'),
      "width": "30",
      "alt": "spotlight icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_title"
  }, [_vm._v("Spotlight video")])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n          Download the app to upload a video for your spotlight.\n          "), _c('br'), _vm._v("\n          When potential subscibers preview your content they will see your\n          video.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "_highlight"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("Things to mention in your video:")]), _vm._v(" "), _c('ul', {
    staticClass: "_highlight-list"
  }, [_c('li', [_vm._v("Who you are")]), _vm._v(" "), _c('li', [_vm._v("The type of content you’re offering")]), _vm._v(" "), _c('li', [_vm._v("\n              Run up your streams! Their subscription is shared with the\n              creators they stream most!\n            ")])])]), _vm._v(" "), _c('hr', {
    staticClass: "mb-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "store-badge"
  }, [_c('div', {
    staticClass: "qr-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.renderQR,
      "width": "130",
      "alt": _vm.altText
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "badges"
  }, [_c('div', {
    staticClass: "_title"
  }, [_vm._v("\n              Scan QR code.\n              "), _c('br'), _vm._v("\n              Download the app.\n            ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "ios-store mr-3",
    attrs: {
      "src": _vm.iosStore,
      "width": "30%",
      "alt": "ios app store icon"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "android-store",
    attrs: {
      "src": _vm.androidPlaystore,
      "width": "30%",
      "alt": "android app store icon"
    }
  })])], 1)])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "featured-card": ""
    }
  }, [_c('div', {
    staticClass: "card-wrapper"
  }, [_c('div', {
    staticClass: "card-image",
    style: (("background-image: url(" + _vm.userImage + ");}"))
  }, [_c('div', {
    staticClass: "featured-artist dflex justify-space-between align-center"
  }, [_c('div', [_c('div', {
    staticClass: "__label"
  }, [_vm._v("Subscribe to support")]), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_c('user-tag', {
    attrs: {
      "user": _vm.currentUser
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "volume allChildrenCenter"
  }, [(true) ? _c('v-icon', [_vm._v("volume_up")]) : _c('v-icon', [_vm._v("volume_off")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card-details"
  }, [_c('img', {
    staticClass: "mb-2",
    attrs: {
      "src": require('@/assets/nav_logo_primary.png'),
      "width": "100",
      "alt": "yousound logo"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n              Get full access to all creators & their content.\n              "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("50%")]), _vm._v(" of your subscription shared with creators you stream the most.\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("1 month free, then $10/month.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2 showPlanBtn",
    attrs: {
      "depressed": "",
      "block": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showPlan = true;
      }
    }
  }, [_vm._v("Start 30 day free trial")])], 1)])])], 1) : _vm._e(), _vm._v(" "), (_vm.showPlan) ? _c('AuthPlan') : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b632f2a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/downloadApp.vue
// module id = 1633
// module chunks = 180